import { CSSProperties } from 'react'
import { styled } from '@mui/material'

export const ScollToBreakdown = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('sm')]: { textAlign: 'right' },
}))

export const s = {
  errorChip: {
    margin: 'auto 0',
    marginTop: 12,
    width: '100%',
  },
  editBookButton: {
    borderColor: '#AF231C',
    backgroundColor: '#FFFFFF',
    fontWeight: 600,
    fontSize: '16px',
    marginTop: '32px',
    color: '#AF231C',
  } as CSSProperties,
  requestSectionCard: {
    border: 'none',
    borderRadius: '8px',
    padding: '36px',
    position: 'sticky',
    marginTop: '24px',
    top: '80px',
    boxShadow: 'none',
  } as CSSProperties,
  successButton: {
    borderColor: '#187759',
    backgroundColor: '#187759',
  } as CSSProperties,
  section: {
    border: '1px solid #FF0000'
  },
  amount: {
    fontSize: '24px',
    padding: '3.8px 0',
    fontWeight: 600,
    color: '#1F1F1F',
  },
  costTotal: {
    fontSize: '16px',
    fontWeight: 500,
    color: '#1F1F1F',
  },
  totalSection: {
    display: 'flex',
    alignItems: 'end',
    justifyContent: 'end',
  } as CSSProperties,
  scollToBreakdown: {
    fontSize: '14px',
    padding: '0px',
    fontWeight: 600,
    color: '#AF231C',
    textTransform: 'none',
  } as CSSProperties,
  modalOk: {
    textTransform: 'none',
  }
}
